import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { PageHeader } from '@/components/common';
import { CampaignList, GlobalPromptsBanner } from '@/components/campaigns';

/**
 * Campaigns (projects) listing page.
 */
const CampaignsPage: React.FC = () => {
    const [hasCampaignError, setHasCampaignError] = useState(false);

    return (
        <Box>
            <PageHeader>
                <Typography variant="h2" component="h1">
                    Projects
                </Typography>
                <Typography variant="body2" component="p" color="gray.60">
                    Displaying all active projects
                </Typography>
            </PageHeader>
            <Box p={2}>
                {!hasCampaignError && <GlobalPromptsBanner />}
                <CampaignList onError={setHasCampaignError} />
            </Box>
        </Box>
    );
};

export default CampaignsPage;
